import { formatAmount } from "../../i18n/money";

/**
 * The currencies an amount may be stated in (security code review R-5; Web
 * Director, 2026-10-17: USD only until Backend names the currencies Lura
 * charges in). Intl's minor-unit exponent differs from Stripe's for HUF,
 * TWD, UGX and ISK; anything else is not stated ("check your email").
 */
export const STATED_CURRENCIES: ReadonlySet<string> = new Set(["USD"]);

/**
 * An amount in a currency's MINOR units (Backend: cents, "…InCents", with an
 * ISO 4217 uppercase `currency`), by Book's one money rule (i18n/money.ts:
 * "$20", "$12.50"), or null when either is unusable. The minor-unit exponent
 * comes from Intl, so a zero-decimal currency (JPY) is not divided by 100.
 */
export function formatMinorUnits(minor: number, currency: string | null, locale: string): string | null {
  if (!Number.isSafeInteger(minor) || minor < 0 || currency === null || !/^[A-Z]{3}$/.test(currency)) return null;
  try {
    return formatAmount(minor, currency, locale);
  } catch {
    return null;
  }
}
